import React from "react";

import { Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import EmailIcon from "../../images/email_icon.svg";
import TelIcon from "../../images/tel_icon.svg";
import LocationIcon from "../../images/location_icon.svg";

import SocialLinks from "./SocialLinks";
import { useStaticQuery, graphql } from "gatsby";
import { ContactsWrapper } from "../../components/styles";

const getData = graphql`
  query {
    site {
      siteMetadata {
        address
        email
        phone
      }
    }
  }
`;

const Contacts = () => {
  const { site } = useStaticQuery(getData);
  const { siteMetadata } = site;
  const data = [
    { icon: EmailIcon, text: siteMetadata.email, alt: "" },
    { icon: TelIcon, text: siteMetadata.phone, alt: "" },
    { icon: LocationIcon, text: siteMetadata.address, alt: "" },
  ];
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <ContactsWrapper>
      {data.map((item, i) => {
        return (
          <Stack direction="row" alignItems="center" key={`${item.text}-${i}`}>
            <img src={item.icon} alt={item.alt} />
            <Typography
              variant={matches ? "h6" : "subtitle2"}
              color="common.white"
              ml={2}
            >
              {item.text}
            </Typography>
          </Stack>
        );
      })}
      <SocialLinks />
    </ContactsWrapper>
  );
};

export default Contacts;
